import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Image, Form } from 'semantic-ui-react';
import { userActions } from '../actions';
import Strings from './../common/Strings';
import { capitalize } from '../helpers/string';
import './Login.css';
import './Welcome.css';

class Welcome extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      companyName: '',
      file: null,
      previewImgURL: '',
    };
  }

  submit = e => {
    e.preventDefault();

    const { companyName, file } = this.state;
    const { dispatch } = this.props;
    const user = {
      companyName: `${capitalize(companyName)}`,
    };
    dispatch(userActions.updateProfile(user, file));
  };

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  generatePreviewImgUrl(file, callback) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => callback(reader.result);
  }

  onFileChange = event => {
    const file = event.target.files[0];

    // User cancelled
    if (!file) {
      return;
    }

    this.generatePreviewImgUrl(file, previewImgURL => {
      this.setState({ file, previewImgURL });
    });
  };

  render() {
    const { companyName, previewImgURL } = this.state;
    const uploadImage = previewImgURL ? (
      <Image id="upload-image" className="upload-img" src={previewImgURL} />
    ) : (
      <div id="upload-image" className="upload-img" />
    );
    const uploadImageText = previewImgURL ? null : (
      <p id="upload-image-text">{Strings.WELCOME.companyLogo}</p>
    );
    const uploadImagePlus = previewImgURL ? null : (
      <Image className="upload-img-plus" src="/logo-plus.png" />
    );
    return (
      <div className="welcome">
        <div className="welcome-form">
          <Image id="wave-image" className="wave-img" src="/wave.png" />
          <Form
            id="welcome-form"
            onSubmit={this.submit}
            loading={this.props.isUserLoading}
          >
            <p id="welcome-info-title">{Strings.WELCOME.welcome}</p>
            <p id="welcome-info-text">{Strings.WELCOME.welcomeBrief}</p>
            <Form.Input
              id="company-name-input"
              placeholder={Strings.WELCOME.companyNameHint}
              name="companyName"
              value={companyName}
              onChange={this.handleChange}
            />
            <div
              className="upload-img-container"
              onClick={() => {
                window.document.getElementById('upload-image-input').click();
              }}
            >
              {uploadImage}
              {uploadImagePlus}
              {uploadImageText}
              <input
                type="file"
                id="upload-image-input"
                accept="image/x-png,image/gif,image/jpeg"
                onChange={this.onFileChange}
              />
            </div>
            <div className="button-wrapper">
              <Form.Button
                id="submit-button"
                className="button-green"
                content={Strings.WELCOME.go}
                primary
                disabled={!companyName}
              />
            </div>
          </Form>
        </div>
        <div className="space" />
      </div>
    );
  }
}

Welcome.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isUserLoading: PropTypes.bool,
};

Welcome.defaultProps = {
  isUserLoading: false,
};

const mapStateToProps = state => ({
  isUserLoading: state.uiState.isUserLoading,
});

export default connect(mapStateToProps)(Welcome);



// WEBPACK FOOTER //
// ./src/components/Welcome.js